import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zapier',
  templateUrl: './zapier.component.html',
  styleUrls: ['./zapier.component.css']
})
export class ZapierComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
